import { apiKeyKey } from '../keys'
import { useQueryClient } from '@tanstack/react-query'
import { Logger, type ApiKeyData } from '@terros/common'

const logger = new Logger('useApiKeyCache')

export function useApiKeyCache() {
  const queryClient = useQueryClient()
  return {
    clearList: () => {
      logger.verbose('invalidateQueries apiKeys')
      queryClient.invalidateQueries({ queryKey: apiKeyKey() })
    },
    addItem: (item: ApiKeyData) => {
      logger.verbose('addItem apiKey', item)
      queryClient.setQueryData<ApiKeyData[]>(apiKeyKey(), (old) => [...(old || []), item])
    },
    replaceItem: (item: ApiKeyData) => {
      logger.verbose('replaceItem apiKey', item)
      queryClient.setQueryData<ApiKeyData[]>(apiKeyKey(), (old) => {
        if (!old) {
          return [item]
        }
        return old.map((t) => (t.createdAt === item.createdAt ? item : t))
      })
    },
    removeItem: (createdAt: number) => {
      logger.verbose('removeItem apiKey', createdAt)
      queryClient.setQueryData<ApiKeyData[]>(apiKeyKey(), (old) => old?.filter((t) => t.createdAt !== createdAt))
    },
  }
}
